export enum PaymentModeEnum {
  Cash = 1,
  Cheque = 2,
  DD = 3,
  OnlineTransfer = 4
}

export type PaymentMode = {
  [key in PaymentModeEnum]: string;
};

export const PAYMENT_MODE_ENUM_LIST: PaymentMode = {
  [PaymentModeEnum.Cash]: 'Cash',
  [PaymentModeEnum.Cheque]: 'Cheque',
  [PaymentModeEnum.DD]: 'DD',
  [PaymentModeEnum.OnlineTransfer]: 'OnlineTransfer'
};
